export default __webpack_public_path__ + "static/media/200.e152ac58.jpg";